import { LocalizeController } from "@shoelace-style/localize";
import { registerTranslation } from "@shoelace-style/localize";
import "./translations/en.js";
class I18nController extends LocalizeController {
}
export {
  I18nController,
  registerTranslation
};
//# sourceMappingURL=i18n.js.map
